import React from "react"

import {FieldViewGroupProps} from "../../../../render/group/@type"

// const debug = "FieldColor_ViewGroup"
const debug = false

export default function FieldColor_ViewGroup(props: FieldViewGroupProps) {

    const value     = props.field.getViewValue(props.model)
    const option    = props.field._getOption(value)

    debug && console.log(debug, 'render', value)

    const isEmpty       = !(option.value || value)

    const classes       = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)
    const iconClasses   = Classes("ui5-color-picker s-17", props.className, {
        ["gd-c-{0}".f(option.value || value)]   : !isEmpty,
        'empty'                                 : isEmpty
    })

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <div className={iconClasses}/>
                </div>
            }
        </div>
    )
}
